import React from "react";
import { Button, Icon } from "react-materialize";

export default function BtnEditNotification() {
  return (
    <a
      href="/employees/notification"
      target="_blank"
      rel="noreferrer"
    >
      <Button
        flat
        node="button"
        waves="light"
        className="btn-top-right textcolor-green"
        id="btn-editnotification"
      >
        Edit Notifications
        <Icon right>notifications</Icon>
      </Button>
    </a>
  );
}
